import { render, staticRenderFns } from "./NewJobbookingView.vue?vue&type=template&id=0b9b5c0c"
import script from "./NewJobbookingView.vue?vue&type=script&lang=ts"
export * from "./NewJobbookingView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports